export default __webpack_public_path__ + "static/media/banner.252a0e8f.webp";